import { render, staticRenderFns } from "./of_tree.vue?vue&type=template&id=4b37f32c&scoped=true&"
import script from "./of_tree.vue?vue&type=script&lang=js&"
export * from "./of_tree.vue?vue&type=script&lang=js&"
import style0 from "./of_tree.vue?vue&type=style&index=0&id=4b37f32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37f32c",
  null
  
)

export default component.exports